import styled from 'styled-components';

export const UsuariosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .searchBarContainer {
    display: flex;
    gap: 16px;
    width: 100%;
  }
`;

export const Row = styled.tr`
  td {
    &:last-child {
      font-size: 24px;
    }
  }
`;
